import { render } from "./CloudMentorshipView.vue?vue&type=template&id=23a3cd7e&scoped=true"
const script = {}

import "./CloudMentorshipView.vue?vue&type=style&index=0&id=23a3cd7e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a3cd7e"]])

export default __exports__